import MessagesState from "./messages.state";
import MessagesTypes from "./messages.types";
import AnyAction from "store/anyAction";
import AppTypes from "store/app/app.types";
import { SAMessageType } from "@missionlabs/smartagent-chat-components-lib/dist/ChatMessage/chat-message.types";

const messagesReducer = (state: MessagesState = [], action: AnyAction) : MessagesState => {
    switch (action.type) {
        // case MessagesTypes.SEND_MESSAGE:
        //     if (typeof action.payload.message === 'string') {
        //         console.warn('message type must be type ChatMessage in reducer')
        //         return state
        //     }
        //     return [...state, action.payload.message]
        case MessagesTypes.SEND_FILE:
        case MessagesTypes.NEW_MESSAGE:
            if (action.payload.role !== 'CUSTOMER') {
                const nonCustomerMessages = state.filter(message => message.role !== 'CUSTOMER');
                const lastNonCustomerMessage =
                    nonCustomerMessages.length > 0
                        ? nonCustomerMessages[nonCustomerMessages.length - 1]
                        : undefined;
                if (
                    lastNonCustomerMessage &&
                    (lastNonCustomerMessage.content as SAMessageType)?.type === 'HOLDING_STATUS'
                ) {
                    const lastMessageIndex = state.findIndex(
                        m => m.id === lastNonCustomerMessage.id
                    );
                    state.splice(lastMessageIndex, 1);
                }
            }
            return [...state, ...[action.payload].flat()];
        case MessagesTypes.SET_MESSAGE_STATUS:
            return state.map((msg) => {
                if (msg.id !== action.payload.id) return msg;

                return {
                    ...msg,
                    sendStatus: action.payload.status
                };
            });
        case MessagesTypes.SET_DELIVERED_TIMESTAMP:            
            return state.map((msg) => {
                return {
                    ...msg,
                    deliveredTimestamp: msg.deliveredTimestamp ? msg.deliveredTimestamp : action.payload.deliveredTimestamp,
                };
            });
        case MessagesTypes.SET_READ_TIMESTAMP:
            return state.map((msg) => {
                if (msg.role !== 'CUSTOMER') return msg

                return {
                    ...msg,
                    readTimestamp: msg.readTimestamp ? msg.readTimestamp : action.payload.readTimestamp,
                };
            });
        case MessagesTypes.MARK_CHAT_MESSAGE_RECEIPTS_AS_READ:
            return state.map(msg => {
                if (msg.readTimestamp) return msg;

                return {
                    ...msg,
                    readTimestamp: (new Date()).toISOString()
                }
            })
        case AppTypes.START_NEW_CHAT:
            return [];
        default:
            return state;
    }
}

export default messagesReducer;
